import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Citizens } from './citizens.model';
import * as CitizensActions from './citizens.actions';

export const citizensesFeatureKey = 'citizenses';

export interface State extends EntityState<Citizens> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Citizens> = createEntityAdapter<Citizens>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensActions.addCitizens,
    (state, action) => adapter.addOne(action.citizens, state)
  ),
  on(CitizensActions.upsertCitizens,
    (state, action) => adapter.upsertOne(action.citizens, state)
  ),
  on(CitizensActions.addCitizenss,
    (state, action) => adapter.addMany(action.citizenss, state)
  ),
  on(CitizensActions.upsertCitizenss,
    (state, action) => adapter.upsertMany(action.citizenss, state)
  ),
  on(CitizensActions.updateCitizens,
    (state, action) => adapter.updateOne(action.citizens, state)
  ),
  on(CitizensActions.updateCitizenss,
    (state, action) => adapter.updateMany(action.citizenss, state)
  ),
  on(CitizensActions.deleteCitizens,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensActions.deleteCitizenss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensActions.loadCitizenss,
    (state, action) => adapter.setAll(action.citizenss, state)
  ),
  on(CitizensActions.clearCitizenss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
